import React, { useEffect, useState } from "react";
import { IonContent, IonModal, IonSpinner } from "@ionic/react";
import { IDeleteEvidenceModal } from "@interfaces/Components";

const DeleteEvidenceModal: React.FC<IDeleteEvidenceModal> = (props) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  const handleDelete = async () => {
    setIsDeleting(true);
    await props.deletePressed();
    setIsDeleting(false);
  };

  return (
    <IonModal
      id="delete-draft-modal"
      isOpen={visible}
      backdropDismiss={false}
      canDismiss={true}
      onDidDismiss={() => setVisible(false)}
      className="fullscreen"
    >
      <IonContent>
        <div className="flex h-full flex-col justify-between">
          <div className="mt-[16px] px-[16px]">
            <div className="text-center text-[20px] font-bold leading-default tracking-[-0.1px] text-grey-90">
              {props.isDraft
                ? "Are you sure you want to delete this draft?"
                : "Are you sure you want to delete this piece of evidence?"}
            </div>
            <div className="mt-[8px] text-center text-[15px] leading-[1.33] tracking-[-0.3px] text-grey-90">
              {props.isDraft
                ? "If you delete this draft, all of your content you've added here will be lost"
                : "If you delete this piece of evidence, all the content you've added will be lost"}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="border-t border-t-grey-30">
              <button
                className="h-[48px] w-full"
                onClick={handleDelete}
                disabled={isDeleting}
              >
                <div className="flex items-center justify-center text-center text-[16px] font-semibold leading-default tracking-default text-cta-red">
                  {isDeleting ? (
                    <IonSpinner className="h-[20px] w-[20px] text-cta-red" />
                  ) : props.isDraft ? (
                    "Delete draft"
                  ) : (
                    "Delete evidence"
                  )}
                </div>
              </button>
            </div>
            <div className="border-t border-t-grey-30">
              <button
                className="h-[48px] w-full"
                onClick={props.cancelPressed}
                disabled={isDeleting}
              >
                <div className="text-center text-[16px] leading-default tracking-default text-cta-blue">{"Cancel"}</div>
              </button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default DeleteEvidenceModal;
